(function (app) {
    app.provider('tour', [
        function () {
            this.$get = ['$mdDialog', '$cookies', '$q', function ($mdDialog, $cookies, $q) {
                var service = {};

                var tour = {
                    name: '',
                    status: {
                        active: false
                    },
                    steps: []
                };

                function _createModal(tour) {
                    $mdDialog.show({
                        templateUrl: "App/Components/TourModal/tour-modal-template.html",
                        controller: "tourModalController",
                        controllerAs: "$ctrl",
                        locals: {
                            tour: tour
                        },
                        bindToController: true
                    });
                }

                function _extendSteps(steps) {
                    return $q(function (resolve, reject) {

                        _.forEach(steps, function (step) {
                            step = Object.assign(step, {
                                index: steps.indexOf(step),
                                isActive: steps.indexOf(step) === 0 ? true : false,
                                next: function () {
                                    var nextIndex = this.index + 1;
                                    this.isActive = false;
                                    return steps[nextIndex].isActive = true;
                                },
                                prev: function () {
                                    var prevIndex = this.index - 1;
                                    this.isActive = false;
                                    return steps[prevIndex].isActive = true;
                                }
                            });

                            resolve(tour);
                        });
                    });
                }

                service.getTourByName = function (name) {
                    return JSON.parse($cookies.get(name));
                };

                service.createTour = function (_tour) {
                    tour = {
                        name: _tour.name,
                        status: {
                            active: true
                        },
                        steps: _tour.steps
                    };
                    var promise = _extendSteps(tour.steps);
                    promise.then(function () {
                        _createModal(tour);
                        $cookies.put(tour.name, tour.status.active);
                        return tour;
                    });

                };

                this.setTourName = function (value) {
                    return tour.name = value;
                };

                return service;
            }];
        }
    ]);

})(window.app);
